import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  Rating,
  Typography,
} from "@mui/material";
import Table from "../../Component/Common/Table";
import Button from "../../Component/Common/Button";
import { ReactComponent as TrashIcon } from "../../assets/icons/trashIcon.svg";
import { ReactComponent as EditIcon } from "../../assets/icons/EditBtn.svg";
import AddIcon from "@mui/icons-material/Add";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CreateLesson from "../../Component/dialogue/CreateLesson";
import CreateQuizQuestion from "../../Component/dialogue/CreateQuizQuestion";
import QuizQuestionsList from "./QuizQuestionsList";
import {
  deleteLesson,
  deleteOrgLesson,
  getEnrolledUsers,
  updateCourseAccess,
} from "../../store/course/course.action";
import { warning } from "../../util/Alert";
import Pagination from "../../Component/Common/Pagination";
import noImageFrom from "../../assets/images/noimage.png";
import MultiButton from "../../Component/extra/MultiButton";
import { handleOpenNew } from "../../util/Dialogue";
import CertificatePreview from "../../Component/Common/CertificatePreview";
import dayjs from "dayjs";
import DataActions from "../../Component/Common/DataActions";
import ManageCourseAccess from "../../Component/dialogue/ManageCourseAccess";

const CourseDetail = ({ selectedCourse, setSelectedCourse }) => {
  const dispatch = useDispatch();
  const { profile, tokenData } = useSelector((state) => state.loggedUser);
  const { dialogueType } = useSelector((state) => state.dialogue);
  const { defaultCurrency } = useSelector((state) => state.currency);

  const [selectedTab, setSelectedTab] = useState("Lessons");
  const [enrolledUserPage, setEnrolledUserPage] = useState(1);
  const [enrolledUserSize, setEnrolledUserSize] = useState(20);
  const [searchText, setSearchText] = useState("");
  const [enrolledSearchText, setEnrolledSearchText] = useState("");
  const [lessonIdForQuiz, setLessonIdForQuiz] = useState(null);
  const [lessonQuiz, setLessonQuiz] = useState(null);
  const [showQuizList, setShowQuizList] = useState(false);
  const [selectedLessonIdForQuiz, setSelectedLessonIdForQuiz] = useState(null);

  const [enrolledUsers, setEnrolledUsers] = useState([]);
  const [totalEnrolledUsers, setTotalEnrolledUsers] = useState(0);

  const [editingLessonData, setEditingLessonData] = useState(null);
  const [selectedAccessIdsToRemove, setSelectedAccessIdsToRemove] = useState(
    [],
  );

  const certificateData = selectedCourse?.certificateSettings?.contents || {};
  const accessTo = selectedCourse?.accessTo || [];

  const isCreator =
    tokenData?._id === selectedCourse.creatorId ||
    profile?.role === "org_admin" ||
    profile?.role === "org_owner";
  const isCoursePublished = selectedCourse?.isPublished;

  const lessonsMapData = [
    {
      Header: "Title",
      Cell: ({ row }) => <p className="text-start px-2">{row.title}</p>,
    },
    {
      Header: "Video",
      Cell: ({ row }) => (
        <div>
          <video
            controls
            width="150px"
            height="100px"
            style={{ borderRadius: "10px" }}
            src={row.video.url}
          />
        </div>
      ),
    },
    {
      Header: "Supporting File",
      Cell: ({ row }) => (
        <div className="row gap-2 justify-content-center align-items-center flex-column px-4">
          {row.fileUrls && row.fileUrls.length > 0
            ? row.fileUrls.map((file, index) => (
                <a
                  key={index}
                  href={file.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-sm btn-outline-primary mb-1"
                  style={{ width: "fit-content" }}
                >
                  {file.name || `File ${index + 1}`}
                </a>
              ))
            : "-"}
        </div>
      ),
    },
    {
      Header: "Duration",
      Cell: ({ row }) => (
        <span className="">{row.duration ? `${row.duration} Min` : "-"}</span>
      ),
    },
    {
      Header: "Quiz",
      Cell: ({ row }) => (
        <div className="text-center">
          {row.quiz ? (
            <div>
              <p className="mb-1">
                <strong>Questions:</strong> {row.quiz.questions.length}
              </p>
              <div className="d-flex align-items-center justify-content-center gap-2">
                <button
                  className="btn btn-outline-primary btn-sm"
                  onClick={() => handleViewQuiz(row)}
                >
                  Look Quiz
                </button>

                {!isCoursePublished && (
                  <button
                    className="btn btn-outline-success btn-sm"
                    onClick={() => {
                      setLessonIdForQuiz(row._id);
                      setLessonQuiz(row.quiz);
                      handleOpenNew(dispatch, "createQuiz");
                    }}
                  >
                    Add Question
                  </button>
                )}
              </div>
            </div>
          ) : (
            <span className="text-muted">
              <button
                className="btn btn-outline-success btn-sm"
                onClick={() => {
                  setLessonIdForQuiz(row._id);
                  setLessonQuiz(row.quiz);
                  handleOpenNew(dispatch, "createQuiz");
                }}
              >
                Create Quiz
              </button>
            </span>
          )}
        </div>
      ),
    },
    ...(!isCoursePublished
      ? [
          {
            Header: "Actions",
            Cell: ({ row }) => (
              <div className="d-flex justify-content-center gap-4">
                <Button
                  className="icon-btn"
                  startIcon={<EditIcon />}
                  onClick={() => handleEditLesson(row)}
                />
                <Button
                  className="icon-btn"
                  startIcon={<TrashIcon />}
                  onClick={() => handleDeleteLesson(row)}
                />
              </div>
            ),
          },
        ]
      : []),
  ];

  const adminLessonsMapData = [
    {
      Header: "Title",
      Cell: ({ row }) => <p className="text-start px-2">{row.title}</p>,
    },
    {
      Header: "Video",
      Cell: ({ row }) => (
        <div>
          <video
            controls
            width="150px"
            height="100px"
            style={{ borderRadius: "10px" }}
            src={row.video.url}
          />
        </div>
      ),
    },
    {
      Header: "Supporting File",
      Cell: ({ row }) => (
        <div className="row gap-2 justify-content-center align-items-center flex-column px-4">
          {row.fileUrls && row.fileUrls.length > 0
            ? row.fileUrls.map((file, index) => (
                <a
                  key={index}
                  href={file.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-sm btn-outline-primary mb-1"
                  style={{ width: "fit-content" }}
                >
                  {file.name || `File ${index + 1}`}
                </a>
              ))
            : "-"}
        </div>
      ),
    },
    {
      Header: "Duration",
      Cell: ({ row }) => (
        <span className="">{row.duration ? `${row.duration} Min` : "-"}</span>
      ),
    },
    {
      Header: "Quiz",
      Cell: ({ row }) => (
        <div className="text-center">
          {row.quiz ? (
            <div>
              <p className="mb-1">
                <strong>Questions:</strong> {row.quiz.questions.length}
              </p>
              <div className="d-flex align-items-center justify-content-center gap-2">
                <button
                  className="btn btn-outline-primary btn-sm"
                  onClick={() => handleViewQuiz(row)}
                >
                  Look Quiz
                </button>
              </div>
            </div>
          ) : (
            <span className="text-muted">No Quiz</span>
          )}
        </div>
      ),
    },
  ];

  const enrolledUserColumns = [
    {
      Header: "ID",
      Cell: ({ row }) => (
        <span className="text-capitalize">{row.userId?.uniqueId}</span>
      ),
    },
    {
      Header: "Name",
      Cell: ({ row }) => <span>{row.userId?.nickName || "N/A"}</span>,
    },
    {
      Header: "Email",
      Cell: ({ row }) => <span>{row.userId?.email || "N/A"}</span>,
    },
    {
      Header: "Enrolled Date",
      Cell: ({ row }) => (
        <span>{dayjs(row.enrolledDate).format("DD MMM YYYY") || "N/A"}</span>
      ),
    },
    {
      Header: "Payment Id",
      Cell: ({ row }) => <span>{row.paymentId || "-"}</span>,
    },
    {
      Header: "Progress",
      Cell: ({ row }) => <span>{row.progress || "0"}%</span>,
    },
    {
      Header: "Lessons Completed",
      Cell: ({ row }) => <span>{row.completedLessons || "0"}</span>,
    },
    {
      Header: "Total Lessons",
      Cell: ({ row }) => <span>{row.totalLessons || "0"}</span>,
    },
    {
      Header: "Quiz Score",
      Cell: ({ row }) => (
        <span>
          {row.quizCompletionPercentage
            ? `${row.quizCompletionPercentage}%`
            : "-"}
        </span>
      ),
    },
    {
      Header: "Status",
      Cell: ({ row }) => <span className="text-capitalize">{row.status}</span>,
    },
    {
      Header: "Completion Date",
      Cell: ({ row }) => (
        <span>
          {row.completionDate
            ? new Date(row.completionDate).toLocaleDateString()
            : "-"}
        </span>
      ),
    },
    ...(selectedCourse?.enableCertification
      ? [
          {
            Header: "Certificate Issued At",
            Cell: ({ row }) => (
              <span>
                {row.certificateTimestamp
                  ? new Date(row.certificateTimestamp).toLocaleDateString()
                  : "-"}
              </span>
            ),
          },
          {
            Header: "Certificate",
            Cell: ({ row }) => (
              <span>{row.isCertified ? "Received" : "Pending"}</span>
            ),
          },
        ]
      : []),
  ];

  const handleViewQuiz = (lesson) => {
    setSelectedLessonIdForQuiz(lesson._id);
    setShowQuizList(true);
  };

  const handleBackFromQuiz = () => {
    setShowQuizList(false);
    setSelectedLessonIdForQuiz(null);
  };

  const handleAddQuizQuestion = (lessonId, quiz) => {
    handleOpenNew(dispatch, "createQuiz");
    setLessonIdForQuiz(lessonId);
    setLessonQuiz(quiz);
  };

  const handleEditLesson = (lesson) => {
    handleOpenNew(dispatch, "createLesson");
    setEditingLessonData(lesson);
  };

  const handleAddLessonSuccess = ({ _id: id, quiz }) => {
    handleOpenNew(dispatch, "createQuiz");
    setLessonIdForQuiz(id);
    setShowQuizList(true);
    setSelectedLessonIdForQuiz(id);
    setLessonQuiz(quiz);
  };

  const handleDeleteLesson = (row) => {
    const data = warning();
    data
      .then((res) => {
        if (res) {
          const yes = res.isConfirmed;
          if (yes) {
            const id = row?._id;
            if (tokenData.isOrg) {
              dispatch(deleteOrgLesson(selectedCourse._id, id));
            } else {
              dispatch(deleteLesson(selectedCourse._id, id));
            }
          }
        }
      })
      .catch((err) => console.log(err));
  };

  const toggleAccessRemoval = (orgId) => {
    setSelectedAccessIdsToRemove((prev) =>
      prev.includes(orgId)
        ? prev.filter((id) => id !== orgId)
        : [...prev, orgId],
    );
  };

  const handleRemoveAccess = () => {
    const data = warning();
    data
      .then((res) => {
        if (res?.isConfirmed) {
          const remainingIds = accessTo
            .map((org) => org._id)
            .filter((id) => !selectedAccessIdsToRemove.includes(id));
          dispatch(
            updateCourseAccess(
              selectedCourse._id,
              remainingIds,
              tokenData?.isOrg ? "org" : "admin",
            ),
          );
          setSelectedAccessIdsToRemove([]);
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    // Fetch enrolled users when component mounts
    if (selectedCourse && selectedCourse._id) {
      getEnrolledUsers(selectedCourse._id, {
        page: enrolledUserPage,
        limit: enrolledUserSize,
        searchText: enrolledSearchText,
      })
        .then((users) => {
          setEnrolledUsers(users.data);
          setTotalEnrolledUsers(users.count);
        })
        .catch((error) => {
          console.error("Failed to fetch enrolled users:", error);
        });
    }
  }, [
    selectedCourse,
    dispatch,
    enrolledUserPage,
    enrolledUserSize,
    enrolledSearchText,
  ]);

  // Debouncing for search text
  useEffect(() => {
    const timer = setTimeout(() => {
      setEnrolledUserPage(1);
      setEnrolledSearchText(searchText);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchText]);

  return (
    <div>
      {showQuizList && selectedLessonIdForQuiz ? (
        <QuizQuestionsList
          courseId={selectedCourse._id}
          lessonId={selectedLessonIdForQuiz}
          onAddQuizQuestion={handleAddQuizQuestion}
          onBack={handleBackFromQuiz}
        />
      ) : (
        <>
          <div>
            <Button className="ms-auto" onClick={() => setSelectedCourse()}>
              Back
            </Button>
          </div>
          <div className="py-2">
            <h2>{selectedCourse.title}</h2>
            {selectedCourse.description && <p>{selectedCourse.description}</p>}
          </div>
          <div className="d-flex align-items-start py-2 mb-4">
            <div className="flex-grow-1">
              <h5>Course Overview</h5>
              <div className="d-flex flex-wrap gap-5">
                <p>Language: {selectedCourse.language || "-"}</p>

                <div className="">
                  <p>
                    Duration :{" "}
                    {selectedCourse.duration ? (
                      `${selectedCourse.duration} Min`
                    ) : (
                      <span className="px-2">-</span>
                    )}
                  </p>
                </div>
                <div className="">
                  <p>
                    Difficulty :{" "}
                    {selectedCourse.difficulty ? (
                      `${selectedCourse.difficulty}`
                    ) : (
                      <span className="px-2">-</span>
                    )}
                  </p>
                </div>
                <div className="">
                  <p className="d-flex align-items-center gap-2">
                    Rating :{" "}
                    <Rating
                      value={selectedCourse.averageRating}
                      precision={0.25}
                      readOnly
                    />{" "}
                  </p>
                </div>
              </div>
              <div className="d-flex flex-wrap gap-5">
                <div className="">
                  <p>
                    Certification:
                    {selectedCourse.enableCertification
                      ? " Enabled"
                      : " Disabled"}
                  </p>
                </div>

                <div className="">
                  <p>
                    Certificate Price:{" "}
                    <span className="text-capitalize">
                      {selectedCourse.priceType}
                    </span>
                  </p>
                </div>
                {selectedCourse.amount &&
                selectedCourse.priceType === "paid" ? (
                  <div className="">
                    <p>
                      Price : {defaultCurrency?.symbol} {selectedCourse.amount}
                    </p>
                  </div>
                ) : null}
              </div>
              <div className="d-flex flex-wrap gap-5">
                <div className="">
                  <p>
                    Students Enrolled :{" "}
                    {selectedCourse.usersEnrolled ? (
                      selectedCourse.usersEnrolled
                    ) : (
                      <span className="px-2">-</span>
                    )}
                  </p>
                </div>
                <div className="">
                  <p>
                    Students Completed :{" "}
                    {selectedCourse.courseCompletedByNumber ? (
                      selectedCourse.courseCompletedByNumber
                    ) : (
                      <span className="px-2">-</span>
                    )}
                  </p>
                </div>
                <div className="">
                  <p>
                    Students Certified :{" "}
                    {selectedCourse.userReceivedCertificate ? (
                      selectedCourse.userReceivedCertificate
                    ) : (
                      <span className="px-2">-</span>
                    )}
                  </p>
                </div>
              </div>
              {selectedCourse.pointsToLearn &&
                selectedCourse.pointsToLearn.length > 0 && (
                  <div className="d-flex flex-wrap gap-5">
                    <div>
                      <p className="mb-2 fw-medium">Points to Learn:</p>
                      <ul className="ps-4">
                        {selectedCourse.pointsToLearn.map((point, index) => (
                          <li key={index} style={{ listStyle: "disc" }}>
                            {point}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                )}
            </div>
            <div className="px-5 course-details-image">
              <img
                src={selectedCourse.thumbnail}
                alt="Course thumbnail"
                onError={(e) => (e.target.src = noImageFrom)}
              />
            </div>
          </div>

          {selectedCourse.enableCertification ? (
            <Accordion className="mb-3 bg-transparent">
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="certificate-preview"
                id="certificate-preview"
              >
                <Typography component="span" className="fw-semibold">
                  Certificate Preview
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <div
                  style={{ width: "1000px" }}
                  className="mx-auto w-full bg-white"
                >
                  <CertificatePreview
                    title={certificateData?.title}
                    line1={certificateData?.line1}
                    line2={certificateData?.line2}
                    logos={certificateData?.logos || []}
                    issuers={
                      certificateData?.authorizers?.map((issuer) => ({
                        name: issuer.authorizerName,
                        designation: issuer.authorizerDesignation,
                        signatureImage: issuer.signatureImage,
                      })) || []
                    }
                    bg={certificateData?.bgImage || ""}
                    courseName={
                      certificateData.receivedIn || selectedCourse?.title || ""
                    }
                  />
                </div>
              </AccordionDetails>
            </Accordion>
          ) : null}

          {isCreator && (
            <div className="py-2 mb-4">
              <div className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0">Organization Access</h5>
                <div className="d-flex gap-2">
                  {selectedAccessIdsToRemove.length > 0 && (
                    <Button className="rounded" onClick={handleRemoveAccess}>
                      Remove Selected
                    </Button>
                  )}
                  <Button
                    className="rounded"
                    startIcon={<AddIcon />}
                    onClick={() =>
                      handleOpenNew(dispatch, "manageCourseAccess")
                    }
                  >
                    Add Organization
                  </Button>
                </div>
              </div>

              {accessTo.length ? (
                <div className="d-flex flex-wrap gap-3 mt-3">
                  {accessTo.map((org) => (
                    <div
                      key={org._id}
                      className="d-flex align-items-center gap-2 border rounded px-2 py-1"
                    >
                      <Checkbox
                        checked={selectedAccessIdsToRemove.includes(org._id)}
                        onChange={() => toggleAccessRemoval(org._id)}
                      />
                      <img
                        src={org.logo}
                        alt={org.name}
                        width={28}
                        height={28}
                        style={{ borderRadius: "50%", objectFit: "cover" }}
                        onError={(e) => (e.target.src = noImageFrom)}
                      />
                      <span>{org.name}</span>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-muted mt-2">
                  This course is not shared with any organization.
                </p>
              )}

              {dialogueType === "manageCourseAccess" && (
                <ManageCourseAccess
                  courseId={selectedCourse._id}
                  currentAccessTo={accessTo}
                />
              )}
            </div>
          )}

          <div className="py-2">
            <div className="d-flex justify-content-between align-items-center">
              {isCreator && (
                <MultiButton
                  label={["Lessons", "Users Enrolled"]}
                  multiButtonSelect={selectedTab}
                  setMultiButtonSelect={setSelectedTab}
                />
              )}
              {isCreator && !isCoursePublished ? (
                <div className="new-fake-btn">
                  <Button
                    className={"rounded"}
                    startIcon={<AddIcon />}
                    onClick={() => handleOpenNew(dispatch, "createLesson")}
                  >
                    Add
                  </Button>
                </div>
              ) : null}
            </div>

            {selectedTab === "Lessons" ? (
              <>
                <Table
                  data={selectedCourse.lessons}
                  mapData={isCreator ? lessonsMapData : adminLessonsMapData}
                />

                {dialogueType == "createLesson" && (
                  <CreateLesson
                    courseId={selectedCourse._id}
                    isEditing={!!editingLessonData}
                    editingLessonData={editingLessonData}
                    onEditSuccess={() => setEditingLessonData(null)}
                    onAddSuccess={handleAddLessonSuccess}
                  />
                )}
              </>
            ) : (
              <>
                <DataActions
                  searchInputProps={{
                    placeholder: "Search name, email, status",
                    value: searchText,
                    onValueChange: (value) => setSearchText(value),
                  }}
                />
                <Table
                  data={enrolledUsers}
                  mapData={enrolledUserColumns}
                  noDataMessage="No Enrollement Found!"
                />

                <div className="mt-3">
                  <Pagination
                    totalItem={totalEnrolledUsers}
                    activePage={enrolledUserPage}
                    pageSize={enrolledUserSize}
                    onActivePageChange={setEnrolledUserPage}
                    onPageSizeChange={(size) => {
                      setEnrolledUserPage(1);
                      setEnrolledUserSize(size);
                    }}
                  />
                </div>
              </>
            )}
          </div>
        </>
      )}
      {dialogueType == "createQuiz" && (
        <CreateQuizQuestion
          courseId={selectedCourse._id}
          lessonId={lessonIdForQuiz}
          quiz={lessonQuiz}
        />
      )}
    </div>
  );
};

export default CourseDetail;
